export default __webpack_public_path__ + "static/media/close-red.d6bc9dfa.svg";